import DynamicForm from '@camiloruiiz/dynamic-form';

import { defineNuxtPlugin } from '#app';

import '@camiloruiiz/dynamic-form/dist/assets/asset-8d21aed7.css';

export default defineNuxtPlugin((nuxtApp) => {
  return nuxtApp.vueApp.use(DynamicForm);
});
